import { Button, PlusIcon } from "melco-ui";
import { useTranslation } from "react-i18next";

type GenrateLicenseButtonPropsType = {
  setOpenGenrateLicenseDrawerFunction: (v: boolean) => void
}
export const GenrateLicenseButton: React.FC<GenrateLicenseButtonPropsType> = ({setOpenGenrateLicenseDrawerFunction}) => {
  const { t } = useTranslation();
 
return (
    <div> 
    <Button
      key="generate-license"
      type="primary"
      icon={<PlusIcon />}
      onClick={async () => {
        //const blank = await addBlank();
        setOpenGenrateLicenseDrawerFunction(true);
      }}
     // loading={isLoading}
    >
      {t("licenses.basic.detail.generate.button")}
    </Button>
    </div>
  );
};
